import { CMS_COMMON_API } from 'aster-foundation/core/common/utils/ApiConst';
import PropTypes from 'prop-types';
import { memo, useEffect, useState } from 'react';
import ListOfData from '../../../../public/asterWebLandingPage.json';
import CommonMeta from '@common/Component/CommonMeta/CommonMeta';
import Header from '@common/Component/Header/Header';
import TopBar from '@common/Component/TopBar/TopBar';
import {
  getHomePageJson as fetchHomePageJson,
  getHomePageJsonSSR,
  getReferralPageForGA,
} from '@common/Utility/common-utils';
import { DYNAMIC_DASHBOARD_PARAMETER, HOME_PAGE_JSON_FILE_NAME, INSTORE_DOMAIN, staticAeJson } from '@common/Utility/constants';
import HomePage from 'Epharmacy/HomePage';
import { useSetCommonParams } from '@common/Utility/analytics-common';
import { MY_ASTER_CATEGORY, PAGE_NAME, SCREEN_NAME } from '@common/Constants/analytics';
import { useRouter } from 'next/router';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

export async function getServerSideProps(context) {
  const params = context?.params?.['region]-[lang'] || 'uae-en';
  const spRegion = params?.split('-');
  const region = spRegion?.[0];
  const lang = spRegion?.[1];

  const url = staticAeJson;
  let jsonFile;

  try {
    const staticJsonResponse = await fetch(url);
    jsonFile = await staticJsonResponse.json();
  } catch (error) {
    jsonFile = ListOfData;
  }
  const host = context?.req?.headers?.host;
  const refPageString = context?.req?.headers?.referer?.split('/');
  const referrerPage = context?.req?.headers?.referer ? getReferralPageForGA(refPageString) : 'Epharmacy Homepage';

  const fileName = HOME_PAGE_JSON_FILE_NAME.WEB;
  const result = await fetchHomePageJson(fileName);
  const pharmacyHeaders = new Headers();
  pharmacyHeaders.append('x-country-code', region === 'uae' ? 'AE' : 'SA');
  pharmacyHeaders.append('x-site-time-zone', region === 'uae' ? 'Asia/Dubai' : 'Asia/Riyadh');
  pharmacyHeaders.append('x-language', lang);

  try {
    const cmsPharmaResult = await fetch(`${CMS_COMMON_API}${DYNAMIC_DASHBOARD_PARAMETER.PHARMACY}?channel=Web`, {
      method: 'GET',
      headers: pharmacyHeaders
    });
    const responseData = await cmsPharmaResult.json();
    const pharmacyTemplate = responseData.data?.template || jsonFile;

    let ssrInstore = false;
    if (host.indexOf(INSTORE_DOMAIN) > -1){
      ssrInstore = true;
    }

    return {
      props: {
        result,
        referrerPage,
        pharmacyTemplate,
        ssrInstore
      },
    };
  } catch (error) {
    return {
      props: {
        result,
        referrerPage,
        pharmacyTemplate: jsonFile,
      },
    };
  }
}

async function fetchJsonData() {
  const fileName = HOME_PAGE_JSON_FILE_NAME.WEB;
  let result = await fetchHomePageJson(fileName);
  result = await getHomePageJsonSSR(result);
  return result;
}

function PharmacyHome(props) {
  const router = useRouter();
  const generateURL = useNavigationURL();
  const [jsonDataResult, setJsonDataResult] = useState(props?.result);
  useSetCommonParams({ screen: SCREEN_NAME.AE_HOME, page: PAGE_NAME.AE, category: MY_ASTER_CATEGORY.AE });

  useEffect(() => {
    const handleRouteChange = () => {
      const asUrl = router?.asPath;
      const currentPath = router?.pathname;
      const parsedUrl = new URL(asUrl, window?.location?.origin);
      const queryParams = Object.fromEntries(parsedUrl?.searchParams?.entries());
      if (queryParams?.isFirstOrder === 'true' && currentPath?.includes('/online-pharmacy')) {
        window?.location?.assign(generateURL(`/doctor-consultation/appointments/list`));
      }
    };
    router.events.on('routeChangeStart', handleRouteChange);
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router?.asPath]);

  useEffect(() => {
    if (!props?.result) {
      fetchJsonData().then((result) => {
        setJsonDataResult(result);
      });
    }
  }, []);

  return (
    <>
      <CommonMeta metaData={jsonDataResult?.seo} />
      <TopBar pageType="homepage" screenName="epharmacy homepage" />
      <Header epharmacySearch pageName="Online Pharmacy Home page" ssrInstore={props?.ssrInstore} screenName="Epharmacy Homepage" />
      <div>
        <HomePage cmsPharmacyResult={props?.pharmacyTemplate} referrerPage={props?.referrerPage} />
      </div>
    </>
  );
}

PharmacyHome.propTypes = {
  result: PropTypes.object,
  referrerPage: PropTypes.string,
  pharmacyTemplate: PropTypes.array,
  ssrInstore: PropTypes.bool,
};

PharmacyHome.defaultProps = {
  result: {},
  referrerPage: '',
  pharmacyTemplate: [],
  ssrInstore: false,
};

export default memo(PharmacyHome);
